/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Страна справочника
 * @export
 * @interface Country
 */
export interface Country {
  /**
   * UUID страны
   * @type {string}
   * @memberof Country
   */
  uuid: string
  /**
   * Название страны
   * @type {string}
   * @memberof Country
   */
  name: string
  /**
   * ISO-код страны
   * @type {string}
   * @memberof Country
   */
  code: string
}

/**
 * Check if a given object implements the Country interface.
 */
export function instanceOfCountry(value: object): value is Country {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function CountryFromJSON(json: any): Country {
  return CountryFromJSONTyped(json, false)
}

export function CountryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Country {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    code: json['code'],
  }
}

export function CountryToJSON(value?: Country | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    code: value['code'],
  }
}
